import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5318d5b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "charge-wrap" }
const _hoisted_2 = { class: "charge-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "charge-header-title" }, "账单费用", -1))
const _hoisted_4 = { class: "charge-header-order" }
const _hoisted_5 = { class: "charge-content van-hairline--top van-hairline--bottom" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "charge-content-title" }, "费用明细", -1))
const _hoisted_7 = { class: "charge-bottom" }
const _hoisted_8 = { class: "sum" }

import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { confirmNameplateReissueOrderApplyInvoice } from '@/apis/insurance'
import ApplyInvoiceWrap from '../components/apply-invoice-wrap.vue'
import { getNameplateReissueBillDetail } from '@/apis/insurance'
import { clearToast, showToastLoading } from '@/utils/tools'

export default /*#__PURE__*/_defineComponent({
  __name: 'apply-invoice',
  setup(__props) {

const $route = useRoute()
const detail = ref({
  sum: '',
  orderNum: $route.query.orderNum,
  typeList: [],
})
const $router = useRouter()

async function initPageData() {
  try {
    showToastLoading()
    let data = await getNameplateReissueBillDetail($route.query.guid as string)
    let sum = 0
    detail.value.typeList = data.map((_) => {
      sum = _.pay_amount + sum
      return {
        label: _.name,
        value: _.pay_amount,
      }
    })
    detail.value.sum = sum.toFixed(2)
    clearToast()
  } catch (e) {
    console.log(e)
  }
}
initPageData()

function applySuccess() {
  $router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ApplyInvoiceWrap, {
    isNotDetail: true,
    guid: (_unref($route).query.guid as string),
    onApplySuccess: applySuccess,
    confirmHandle: _unref(confirmNameplateReissueOrderApplyInvoice)
  }, {
    payInfo: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, "订单号：" + _toDisplayString(detail.value.orderNum), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.typeList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "charge-content-detail-item"
            }, [
              _createElementVNode("span", null, _toDisplayString(item.label), 1),
              _createElementVNode("span", null, "￥" + _toDisplayString(item.value), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createTextVNode(" 合计费用："),
            _createElementVNode("span", _hoisted_8, "￥" + _toDisplayString(detail.value.sum), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["guid", "confirmHandle"]))
}
}

})